<template>
  <div>
    <v-breadcrumbs :items="breadcrumbs" class="breadcrumbs" />
    <heading :helpInfo="sidebarCard">
      {{ folderName || $t("sidebar.inspections") }}
    </heading>
    <inspectionTable />
  </div>
</template>

<script>
import inspectionTable from "@/views/inspection/inspectionTable.vue";
import i18n from "../../i18n";
import * as sidebarTextDE from "../../components/api/content/sidebarText-de.json";
import * as sidebarTextEN from "../../components/api/content/sidebarText-en.json";
export default {
  name: "inspection",
  components: { inspectionTable },
  computed: {
    folderName() {
      return this.$route.params.inspectionCategoryName || "";
    },
    breadcrumbs() {
      return [
        {
          text: i18n.t("sidebar.inspections"),
          disabled: false,
          href: "/app/inspectionCategory",
        },
        { text: this.folderName, disabled: true },
      ];
    },
    sidebarCard() {
      if (this.$i18n.locale == "de") {
        return sidebarTextDE.default.inspection;
      } else if (this.$i18n.locale == "en") {
        return sidebarTextEN.default.inspection;
      }
      return sidebarTextDE.default.inspection;
    },
  },
};
</script>
